module.exports = __webpack_public_path__ + "static/media/eighteenth_friendship_way1.5d7d6b76.jpg";